import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift, ArrowRight } from 'lucide-react';

const TOTAL_SPOTS = 500;

export default function FounderBanner({ isLoggedIn }) {
  const navigate = useNavigate();
  const [remaining, setRemaining] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const now = new Date();
    const dayOfYear = Math.floor((now - new Date(now.getFullYear(), 0, 0)) / 86400000);
    const hourFraction = now.getHours() / 24;
    const taken = Math.min(Math.floor(40 + dayOfYear * 2.7 + hourFraction * 3), TOTAL_SPOTS - 12);
    setRemaining(TOTAL_SPOTS - taken);
  }, []);

  if (isLoggedIn || dismissed || remaining === null) return null;

  return (
    <div data-testid="founder-banner" className="mx-3 mt-2.5 mb-1.5">
      <button
        onClick={() => navigate('/login')}
        className="w-full flex items-center gap-2.5 rounded-full px-4 py-2.5 active:scale-[0.98] transition-transform"
        style={{
          background: 'linear-gradient(90deg,#1a1400,#221b00)',
          border: '1px solid #f5c51830',
          fontFamily: 'Sora, sans-serif',
        }}
      >
        <Gift className="w-4 h-4 shrink-0" style={{ color: '#f5c518' }} />
        <p className="flex-1 text-left truncate text-xs font-semibold" style={{ color: '#d5d5d5', fontFamily: 'Sora, sans-serif' }}>
          <span style={{ color: '#f5c518' }}>{remaining}</span> spots de fundador restantes
        </p>
        <span className="flex items-center gap-0.5 shrink-0 text-xs font-bold" style={{ color: '#f5c518', fontFamily: 'Sora, sans-serif' }}>
          Ver <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </button>
    </div>
  );
}
